import { useContext } from 'react';
import { useSnackBar } from '@usealloy/component-library';
import { UserContext } from '~/dashboard/context';
import { typhonAjaxFetch } from '~/helpers/api';

export const useDocumentDownload = () => {
  const { typhonDomain } = useContext(UserContext);
  const addSnackBar = useSnackBar();

  const downloadDocuments = async (
    documentTokens: string | string[],
    fileName?: string,
  ) => {
    try {
      const tokens = Array.isArray(documentTokens)
        ? documentTokens.join(',')
        : documentTokens;
      const isMultiple = Array.isArray(documentTokens) && documentTokens.length > 1;

      const url = `${typhonDomain}/documents/download/${tokens}`;
      const response = await typhonAjaxFetch(
        url,
        { returnResponse: true },
      );

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;

      if (fileName) {
        link.download = fileName;
      } else if (isMultiple) {
        link.download = 'documents.zip';
      } else {
        link.download = 'document';
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      addSnackBar({
        title: Array.isArray(documentTokens) && documentTokens.length > 1
          ? 'Unable to download documents'
          : 'Unable to download document',
        type: 'danger',
        duration: 3000,
      });
    }
  };

  return { downloadDocuments };
};
